import createAction, { createClearAction } from "../../app/createAction";
import {
    ADD_MARKET_DATA_CANDLE_WATCH_ACTION,
    ADD_MARKET_DATA_WATCH_ACTION,
    CANCEL_LITE_TRADE_ORDER_ACTION,
    CANCEL_LITE_TRADE_ORDER_FAILURE,
    CANCEL_LITE_TRADE_ORDER_SUCCESS,
    CLOSE_ALL_POSITIONS_ACTION,
    CLOSE_ALL_POSITIONS_FAILURE,
    CLOSE_ALL_POSITIONS_SUCCESS,
    CLOSE_LITE_TRADE_POSITION_ACTION,
    CLOSE_LITE_TRADE_POSITION_FAILURE,
    CLOSE_LITE_TRADE_POSITION_SUCCESS,
    CREATE_LITE_TRADE_ORDER_ACTION,
    CREATE_LITE_TRADE_ORDER_FAILURE,
    CREATE_LITE_TRADE_ORDER_SUCCESS,
    GET_LITE_TRADE_ACCOUNT_STAT_PL_ACTION,
    GET_LITE_TRADE_ACCOUNT_STAT_PL_FAILURE,
    GET_LITE_TRADE_ACCOUNT_STAT_PL_SUCCESS,
    GET_LITE_TRADE_ASSETS_ACTION,
    GET_LITE_TRADE_ASSETS_FAILURE,
    GET_LITE_TRADE_ASSETS_SUCCESS,
    GET_LITE_TRADE_MARKET_ACTION,
    GET_LITE_TRADE_MARKET_COLLECTION_ACTION,
    GET_LITE_TRADE_MARKET_COLLECTION_FAILURE,
    GET_LITE_TRADE_MARKET_COLLECTION_SUCCESS,
    GET_LITE_TRADE_MARKET_FAILURE,
    GET_LITE_TRADE_MARKET_SUCCESS,
    INIT_LITE_TRADE_ACTION,
    INIT_LITE_TRADE_FAILURE,
    INIT_LITE_TRADE_SUCCESS,
    INIT_UPS_DOWNS_COLLECTION_ACTION,
    INIT_UPS_DOWNS_COLLECTION_FAILURE,
    INIT_UPS_DOWNS_COLLECTION_SUCCESS,
    LOGIN_LITE_TRADE_ACTION,
    LOGIN_LITE_TRADE_FAILURE,
    LOGIN_LITE_TRADE_SUCCESS,
    LOGOUT_LITE_TRADE_ACTION,
    LOGOUT_LITE_TRADE_FAILURE,
    LOGOUT_LITE_TRADE_SUCCESS,
    OPEN_LITE_TRADE_POSITION_ACTION,
    OPEN_LITE_TRADE_POSITION_FAILURE,
    OPEN_LITE_TRADE_POSITION_SUCCESS,
    PING_LITE_TRADE_ACTION,
    PING_LITE_TRADE_FAILURE,
    PING_LITE_TRADE_SUCCESS,
    PROCESS_LITE_TRADE_ORDER_NOTIFICATION,
    PROCESS_LITE_TRADE_POSITION_NOTIFICATION,
    PROCESS_LITE_TRADE_REJECTED_ORDER_NOTIFICATION,
    REMOVE_MARKET_DATA_CANDLE_WATCH_ACTION,
    REMOVE_MARKET_DATA_WATCH_ACTION,
    SET_DESKTOP_TRADE_TABLE_MODE,
    SET_LITE_TRADE_ACCOUNT_METRICS,
    SET_LITE_TRADE_ACCOUNT_PORTFOLIO,
    SET_LITE_TRADE_SOCKET_STATE,
    TChartTimeframes,
    TLiteTradePositionSide,
    UPDATE_LITE_TRADE_CHART_DATA_READY,
    UPDATE_LITE_TRADE_CHART_TIMEFRAMES,
    UPDATE_LITE_TRADE_MARKET_FAVORITE_ASSET_ACTION,
    UPDATE_LITE_TRADE_MARKET_FAVORITE_ASSET_FAILURE,
    UPDATE_LITE_TRADE_MARKET_FAVORITE_ASSET_SUCCESS,
    UPDATE_LITE_TRADE_MARKET_VIEW_ASSET_ACTION,
    UPDATE_LITE_TRADE_MARKET_VIEW_ASSET_FAILURE,
    UPDATE_LITE_TRADE_MARKET_VIEW_ASSET_SUCCESS,
    UPDATE_LITE_TRADE_ORDER_ACTION,
    UPDATE_LITE_TRADE_ORDER_FAILURE,
    UPDATE_LITE_TRADE_ORDER_SUCCESS,
    UPDATE_LITE_TRADE_POSITION_ACTION,
    UPDATE_LITE_TRADE_POSITION_FAILURE,
    UPDATE_LITE_TRADE_POSITION_SUCCESS,
    UPDATE_MARKET_DATA,
    UPDATE_MARKET_DATA_CANDLE,
    UPDATE_POSITION_PL_LAST_SEEN_SIGN_BY_PORTFOLIO_ACTION,
    UPDATE_POSITION_PL_LAST_SEEN_SIGN_BY_PORTFOLIO_SUCCESS,
    UPDATE_POSITION_PL_LAST_SEEN_SIGN_BY_POSITION_CODE_ACTION,
    SET_CHART_DRAW_PANEL_OPENED, INIT_CHART_DRAW_PANEL_OPENED,
} from "./liteTradeConstants";

import {
    ILiteTradeAssets,
    ILiteTradeAssetSymbol,
    ILiteTradeCollectionsItem,
    ILiteTradeConfig,
    ILiteTradeConfigError,
    ILiteTradeLoginError,
    ILiteTradeMarketDataCandleItem,
    ILiteTradeMarketItem,
    ILiteTradeMetric,
    ILiteTradePingError,
    ILiteTradePortfolio,
    ILiteTradePortfolioOrder,
    ILiteTradePortfolioOrderType,
    ILiteTradePortfolioPositionType,
    ILiteTradeSession,
    ILiteTradeStatPl,
    IMarketDataCandleWatcher,
    IOrderCode, TDesktopTradeTableMode
} from "./types/liteTradeReducer.t";
import { ICloseAllPositionsAction } from "./types/liteTradeReducer.t";
import {
    IClosePositionActionPayload,
    IGetLiteTradeMarketActionPayload,
    IGetLiteTradeMarketSuccessPayload,
    IUpdatedPositionPlLastSeenSignByPortfolioActionPayload,
    IUpdatedPositionPlLastSeenSignByPortfolioSuccessPayload,
    IUpdatedPositionPlLastSeenSignByPositionActionPayload,
    IUpdateLiteTradeMarketActionPayload,
    IUpdateLiteTradeMarketFavoriteAssetActionPayload,
} from "./types/liteTradeActions.t"
import { IInitUpsDownsCollectionSuccessPayload } from "./types/liteTradeActions.t";
import { AssetFilledQuantity } from "../Asset/Asset.t";

export const initLiteTradeAction = (payload?: unknown) => createClearAction<typeof INIT_LITE_TRADE_ACTION>(INIT_LITE_TRADE_ACTION, payload);
export const initLiteTradeSuccess = (payload: ILiteTradeConfig) => createAction<typeof INIT_LITE_TRADE_SUCCESS, ILiteTradeConfig>(INIT_LITE_TRADE_SUCCESS, payload);
export const initLiteTradeFailure = (payload: ILiteTradeConfigError) => createAction<typeof INIT_LITE_TRADE_FAILURE, ILiteTradeConfigError>(INIT_LITE_TRADE_FAILURE, payload);

export const pingLiteTradeAction = (payload?: unknown) => createClearAction<typeof PING_LITE_TRADE_ACTION>(PING_LITE_TRADE_ACTION, payload);
export const pingLiteTradeSuccess = (payload: ILiteTradeSession) => createAction<typeof PING_LITE_TRADE_SUCCESS, ILiteTradeSession>(PING_LITE_TRADE_SUCCESS, payload);
export const pingLiteTradeFailure = (payload: ILiteTradePingError) => createAction<typeof PING_LITE_TRADE_FAILURE, ILiteTradePingError>(PING_LITE_TRADE_FAILURE, payload);

export const setLiteTradeSocketState = (payload: number) => createAction<typeof SET_LITE_TRADE_SOCKET_STATE, number>(SET_LITE_TRADE_SOCKET_STATE, payload);

export const loginLiteTradeAction = (payload?: unknown) => createClearAction<typeof LOGIN_LITE_TRADE_ACTION>(LOGIN_LITE_TRADE_ACTION, payload);
export const loginLiteTradeSuccess = (payload: ILiteTradeSession) => createAction<typeof LOGIN_LITE_TRADE_SUCCESS, ILiteTradeSession>(LOGIN_LITE_TRADE_SUCCESS, payload);
export const loginLiteTradeFailure = (payload: ILiteTradeLoginError) => createAction<typeof LOGIN_LITE_TRADE_FAILURE, ILiteTradeLoginError>(LOGIN_LITE_TRADE_FAILURE, payload);

export const logoutLiteTradeAction = (payload?: unknown) => createClearAction<typeof LOGOUT_LITE_TRADE_ACTION>(LOGOUT_LITE_TRADE_ACTION, payload);
export const logoutLiteTradeSuccess = (payload?: unknown) => createClearAction<typeof LOGOUT_LITE_TRADE_SUCCESS>(LOGOUT_LITE_TRADE_SUCCESS, payload);
export const logoutLiteTradeFailure = (payload?: unknown) => createClearAction<typeof LOGOUT_LITE_TRADE_FAILURE>(LOGOUT_LITE_TRADE_FAILURE, payload);

export const setLiteTradeAccountMetrics = (payload: ILiteTradeMetric) => createAction<typeof SET_LITE_TRADE_ACCOUNT_METRICS, ILiteTradeMetric>(SET_LITE_TRADE_ACCOUNT_METRICS, payload);
export const setLiteTradeAccountPortfolio = (payload: ILiteTradePortfolio) => createAction<typeof SET_LITE_TRADE_ACCOUNT_PORTFOLIO, ILiteTradePortfolio>(SET_LITE_TRADE_ACCOUNT_PORTFOLIO, payload);

export const getLiteTradeAssetsAction = (payload?: unknown) => createClearAction<typeof GET_LITE_TRADE_ASSETS_ACTION>(GET_LITE_TRADE_ASSETS_ACTION, payload);
export const getLiteTradeAssetsSuccess = (payload: ILiteTradeAssets) => createAction<typeof GET_LITE_TRADE_ASSETS_SUCCESS, ILiteTradeAssets>(GET_LITE_TRADE_ASSETS_SUCCESS, payload);
export const getLiteTradeAssetsFailure = (payload?: unknown) => createClearAction<typeof GET_LITE_TRADE_ASSETS_FAILURE>(GET_LITE_TRADE_ASSETS_FAILURE, payload);

export const updateMarketDataAction = (payload: ILiteTradeMarketItem[]) => createAction<typeof UPDATE_MARKET_DATA, ILiteTradeMarketItem[]>(UPDATE_MARKET_DATA, payload);
export const updateMarketDataCandleAction = (payload: ILiteTradeMarketDataCandleItem[]) => createAction<typeof UPDATE_MARKET_DATA_CANDLE, ILiteTradeMarketDataCandleItem[]>(UPDATE_MARKET_DATA_CANDLE, payload);

export const closeAllPositionsAction = (payload: ICloseAllPositionsAction) => createAction<typeof CLOSE_ALL_POSITIONS_ACTION, ICloseAllPositionsAction>(CLOSE_ALL_POSITIONS_ACTION, payload);
export const closeAllPositionsSuccess = (payload?: unknown) => createClearAction<typeof CLOSE_ALL_POSITIONS_SUCCESS>(CLOSE_ALL_POSITIONS_SUCCESS, payload);
export const closeAllPositionsFailure = (payload?: unknown) => createClearAction<typeof CLOSE_ALL_POSITIONS_FAILURE>(CLOSE_ALL_POSITIONS_FAILURE, payload);

export const addMarketDataWatchAction = (payload: IMarketDataCandleWatcher) => createAction<typeof ADD_MARKET_DATA_WATCH_ACTION, IMarketDataCandleWatcher>(ADD_MARKET_DATA_WATCH_ACTION, payload);
type IMarketDataCandleWatcherForRemoveAction = {
    symbol?: string;
    fromComponentName?: string;
}
export const removeMarketDataWatchAction = (payload: IMarketDataCandleWatcherForRemoveAction) => createAction<typeof REMOVE_MARKET_DATA_WATCH_ACTION, IMarketDataCandleWatcherForRemoveAction>(REMOVE_MARKET_DATA_WATCH_ACTION, payload);

export const addMarketDataCandleWatchAction = (payload: IMarketDataCandleWatcher) => createAction<typeof ADD_MARKET_DATA_CANDLE_WATCH_ACTION, IMarketDataCandleWatcher>(ADD_MARKET_DATA_CANDLE_WATCH_ACTION, payload);
export const removeMarketDataCandleWatchAction = (payload: IMarketDataCandleWatcher) => createAction<typeof REMOVE_MARKET_DATA_CANDLE_WATCH_ACTION, IMarketDataCandleWatcher>(REMOVE_MARKET_DATA_CANDLE_WATCH_ACTION, payload);

interface ILiteTradePositionNotificationActionPayload {
    filledQuantity: AssetFilledQuantity;
    order: ILiteTradePortfolioOrder;
    portfolio: ILiteTradePortfolio;
}
export const processLiteTradePositionNotificationAction = (payload: ILiteTradePositionNotificationActionPayload) =>
    createAction<typeof PROCESS_LITE_TRADE_POSITION_NOTIFICATION, ILiteTradePositionNotificationActionPayload>(
        PROCESS_LITE_TRADE_POSITION_NOTIFICATION,
        payload,
    );
export const processLiteTradeOrderNotificationAction = (payload: unknown) =>
    createClearAction<typeof PROCESS_LITE_TRADE_ORDER_NOTIFICATION>(PROCESS_LITE_TRADE_ORDER_NOTIFICATION, payload);
export const processLiteTradeRejectedOrderNotificationAction = (payload: unknown) =>
    createClearAction<typeof PROCESS_LITE_TRADE_REJECTED_ORDER_NOTIFICATION>(PROCESS_LITE_TRADE_REJECTED_ORDER_NOTIFICATION, payload);

/**
 * @deprecated use openLiteTradePositionAction/closeLiteTradePositionAction
 */
export const createLiteTradeOrderAction = (payload?: unknown) => createClearAction<typeof CREATE_LITE_TRADE_ORDER_ACTION>(CREATE_LITE_TRADE_ORDER_ACTION, payload);

export interface ICreateLiteTradeOrderSuccessPayload {
    limitPrice: number,
    orderType: ILiteTradePortfolioOrderType,
    quantity: number,
    side: TLiteTradePositionSide,
    stopLoss: number,
    stopLossActive: boolean,
    stopPrice: number,
    symbol: ILiteTradeAssetSymbol,
    takeProfit: number,
    takeProfitActive: boolean,
}

export const createLiteTradeOrderSuccess = (payload: ICreateLiteTradeOrderSuccessPayload) => createAction<typeof CREATE_LITE_TRADE_ORDER_SUCCESS, ICreateLiteTradeOrderSuccessPayload>(CREATE_LITE_TRADE_ORDER_SUCCESS, payload);
export const createLiteTradeOrderFailure = (payload?: unknown) => createClearAction<typeof CREATE_LITE_TRADE_ORDER_FAILURE>(CREATE_LITE_TRADE_ORDER_FAILURE, payload);

export interface IOpenLiteTradePositionActionPayload {
    limitPrice: number;
    onSuccessCallback?: () => void;
    orderType: ILiteTradePortfolioPositionType;
    quantity: number;
    side: TLiteTradePositionSide;
    stopLoss: number;
    stopLossActive: boolean;
    stopPrice: number;
    symbol: ILiteTradeAssetSymbol;
    takeProfit: number;
    takeProfitActive: boolean;
}

export const openLiteTradePositionAction = (payload?: IOpenLiteTradePositionActionPayload) => createAction<typeof OPEN_LITE_TRADE_POSITION_ACTION, IOpenLiteTradePositionActionPayload>(OPEN_LITE_TRADE_POSITION_ACTION, payload);

export interface IOpenLiteTradePositionSuccessPayload {
};
export const openLiteTradePositionSuccess = (payload: IOpenLiteTradePositionSuccessPayload) => createAction<typeof OPEN_LITE_TRADE_POSITION_SUCCESS, IOpenLiteTradePositionSuccessPayload>(OPEN_LITE_TRADE_POSITION_SUCCESS, payload);
export const openLiteTradePositionFailure = (payload?: unknown) => createClearAction<typeof OPEN_LITE_TRADE_POSITION_FAILURE>(OPEN_LITE_TRADE_POSITION_FAILURE, payload);

export const closeLiteTradePositionAction = (payload: IClosePositionActionPayload) => createAction<typeof CLOSE_LITE_TRADE_POSITION_ACTION, IClosePositionActionPayload>(CLOSE_LITE_TRADE_POSITION_ACTION, payload);

export interface ICloseLiteTradePositionSuccessPayload {
}

export const closeLiteTradePositionSuccess = (payload: ICloseLiteTradePositionSuccessPayload) => createAction<typeof CLOSE_LITE_TRADE_POSITION_SUCCESS, ICloseLiteTradePositionSuccessPayload>(CLOSE_LITE_TRADE_POSITION_SUCCESS, payload);
export const closeLiteTradePositionFailure = (payload?: unknown) => createClearAction<typeof CLOSE_LITE_TRADE_POSITION_FAILURE>(CLOSE_LITE_TRADE_POSITION_FAILURE, payload);

export const cancelLiteTradeOrderAction = (payload?: unknown) => createClearAction<typeof CANCEL_LITE_TRADE_ORDER_ACTION>(CANCEL_LITE_TRADE_ORDER_ACTION, payload);

export interface ICancelLiteTradeOrderSuccessPayload {
}

export const cancelLiteTradeOrderSuccess = (payload: ICancelLiteTradeOrderSuccessPayload) => createAction<typeof CANCEL_LITE_TRADE_ORDER_SUCCESS, ICancelLiteTradeOrderSuccessPayload>(CANCEL_LITE_TRADE_ORDER_SUCCESS, payload);
export const cancelLiteTradeOrderFailure = (payload?: unknown) => createClearAction<typeof CANCEL_LITE_TRADE_ORDER_FAILURE>(CANCEL_LITE_TRADE_ORDER_FAILURE, payload);

interface IUpdateLiteTradeOrderPayload {
    initialQuantity?: number;
    takeProfit: number | undefined;
    stopLossActive: boolean;
    initialOrderStopLoss: {
        orderCode: IOrderCode;
    };
    stopLoss: number | undefined;
    symbol: ILiteTradeAssetSymbol;
    orderCode: IOrderCode;
    quantity: number;
    side: TLiteTradePositionSide;
    orderType: ILiteTradePortfolioPositionType;
    limitPrice: number;
    stopPrice: number;
    takeProfitActive: boolean;
    initialOrderTakeProfit?: {
        orderCode: IOrderCode;
    };
    onSuccess?: () => void;
}

export const updateLiteTradeOrderAction = (payload?: IUpdateLiteTradeOrderPayload) =>
    createAction<typeof UPDATE_LITE_TRADE_ORDER_ACTION, IUpdateLiteTradeOrderPayload>(
        UPDATE_LITE_TRADE_ORDER_ACTION,
        payload,
    );
export interface IUpdateLiteTradeOrderSuccessPayload {}
export const updateLiteTradeOrderSuccess = (payload: IUpdateLiteTradeOrderSuccessPayload) => createAction<typeof UPDATE_LITE_TRADE_ORDER_SUCCESS, IUpdateLiteTradeOrderSuccessPayload>(UPDATE_LITE_TRADE_ORDER_SUCCESS, payload);
export const updateLiteTradeOrderFailure = (payload?: unknown) => createClearAction<typeof UPDATE_LITE_TRADE_ORDER_FAILURE>(UPDATE_LITE_TRADE_ORDER_FAILURE, payload);

export const updateLiteTradePositionAction = (payload?: unknown) => createClearAction<typeof UPDATE_LITE_TRADE_POSITION_ACTION>(UPDATE_LITE_TRADE_POSITION_ACTION, payload);
export const updateLiteTradePositionSuccess = (payload?: unknown) => createClearAction<typeof UPDATE_LITE_TRADE_POSITION_SUCCESS>(UPDATE_LITE_TRADE_POSITION_SUCCESS, payload);
export const updateLiteTradePositionFailure = (payload?: unknown) => createClearAction<typeof UPDATE_LITE_TRADE_POSITION_FAILURE>(UPDATE_LITE_TRADE_POSITION_FAILURE, payload);

export const getLiteTradeAccountStatPLAction = (payload?: unknown) => createClearAction<typeof GET_LITE_TRADE_ACCOUNT_STAT_PL_ACTION>(GET_LITE_TRADE_ACCOUNT_STAT_PL_ACTION, payload);
export const getLiteTradeAccountStatPLSuccess = (payload: ILiteTradeStatPl) => createAction<typeof GET_LITE_TRADE_ACCOUNT_STAT_PL_SUCCESS, ILiteTradeStatPl>(GET_LITE_TRADE_ACCOUNT_STAT_PL_SUCCESS, payload);
export const getLiteTradeAccountStatPLFailure = (payload?: unknown) => createClearAction<typeof GET_LITE_TRADE_ACCOUNT_STAT_PL_FAILURE>(GET_LITE_TRADE_ACCOUNT_STAT_PL_FAILURE, payload);

export const getLiteTradeMarketAction = (payload?: unknown) => createClearAction<typeof GET_LITE_TRADE_MARKET_ACTION>(GET_LITE_TRADE_MARKET_ACTION, payload);
export const getLiteTradeMarketSuccess = (payload: IGetLiteTradeMarketSuccessPayload) => createAction<typeof GET_LITE_TRADE_MARKET_SUCCESS, IGetLiteTradeMarketSuccessPayload>(GET_LITE_TRADE_MARKET_SUCCESS, payload);
export const getLiteTradeMarketFailure = (payload?: unknown) => createClearAction<typeof GET_LITE_TRADE_MARKET_FAILURE>(GET_LITE_TRADE_MARKET_FAILURE, payload);

export const updateLiteTradeViewAssetAction = (payload: IUpdateLiteTradeMarketActionPayload) =>
    createAction<typeof UPDATE_LITE_TRADE_MARKET_VIEW_ASSET_ACTION, IUpdateLiteTradeMarketActionPayload>(UPDATE_LITE_TRADE_MARKET_VIEW_ASSET_ACTION, payload);
export const updateLiteTradeViewAssetSuccess = (payload?: unknown) =>
    createClearAction<typeof UPDATE_LITE_TRADE_MARKET_VIEW_ASSET_SUCCESS>(UPDATE_LITE_TRADE_MARKET_VIEW_ASSET_SUCCESS, payload);
export const updateLiteTradeViewAssetFailure = (payload?: unknown) =>
    createClearAction<typeof UPDATE_LITE_TRADE_MARKET_VIEW_ASSET_FAILURE>(UPDATE_LITE_TRADE_MARKET_VIEW_ASSET_FAILURE, payload);

export const getLiteTradeMarketCollectionAction = (payload: IGetLiteTradeMarketActionPayload) =>
    createAction<typeof GET_LITE_TRADE_MARKET_COLLECTION_ACTION, IGetLiteTradeMarketActionPayload>(GET_LITE_TRADE_MARKET_COLLECTION_ACTION, payload);
export const getLiteTradeMarketCollectionSuccess = (payload: ILiteTradeCollectionsItem) =>
    createAction(GET_LITE_TRADE_MARKET_COLLECTION_SUCCESS, payload);
export const getLiteTradeMarketCollectionFailure = (payload?: unknown) =>
    createClearAction(GET_LITE_TRADE_MARKET_COLLECTION_FAILURE, payload);

export const updateLiteTradeMarketFavoriteAssetAction = (payload: IUpdateLiteTradeMarketFavoriteAssetActionPayload) =>
    createAction(UPDATE_LITE_TRADE_MARKET_FAVORITE_ASSET_ACTION, payload);
export const updateLiteTradeMarketFavoriteAssetSuccess = () =>
    createClearAction(UPDATE_LITE_TRADE_MARKET_FAVORITE_ASSET_SUCCESS);
export const updateLiteTradeMarketFavoriteAssetFailure = () =>
    createClearAction(UPDATE_LITE_TRADE_MARKET_FAVORITE_ASSET_FAILURE);

export const initUpsDownsCollectionAction = () =>
    createClearAction(INIT_UPS_DOWNS_COLLECTION_ACTION);
export const initUpsDownsCollectionSuccess = (payload: IInitUpsDownsCollectionSuccessPayload) =>
    createAction(INIT_UPS_DOWNS_COLLECTION_SUCCESS, payload);
export const initUpsDownsCollectionFailure = (payload?: unknown) =>
    createClearAction(INIT_UPS_DOWNS_COLLECTION_FAILURE, payload);

export const updateLiteTradeChartTimeframes = (payload: TChartTimeframes) =>
    createAction<typeof UPDATE_LITE_TRADE_CHART_TIMEFRAMES, TChartTimeframes>(UPDATE_LITE_TRADE_CHART_TIMEFRAMES, payload);
export const updateLiteTradeChartDataReady = (payload: boolean) =>
    createAction<typeof UPDATE_LITE_TRADE_CHART_DATA_READY, boolean>(UPDATE_LITE_TRADE_CHART_DATA_READY, payload);

export const setDesktopTradeTableModeAction = (payload: TDesktopTradeTableMode) => createAction(SET_DESKTOP_TRADE_TABLE_MODE, payload);

export const updatePositionPlLastSeenSignByPortfolioAction = (payload: IUpdatedPositionPlLastSeenSignByPortfolioActionPayload) =>
    createAction(UPDATE_POSITION_PL_LAST_SEEN_SIGN_BY_PORTFOLIO_ACTION, payload);
export const updatePositionPlLastSeenSignByPortfolioSuccess = (payload: IUpdatedPositionPlLastSeenSignByPortfolioSuccessPayload) =>
    createAction(UPDATE_POSITION_PL_LAST_SEEN_SIGN_BY_PORTFOLIO_SUCCESS, payload);

export const updatePositionPlLastSeenSignByPositionCodeAction = (payload: IUpdatedPositionPlLastSeenSignByPositionActionPayload) =>
    createAction(UPDATE_POSITION_PL_LAST_SEEN_SIGN_BY_POSITION_CODE_ACTION, payload);

export const setChartDrawPanelOpenedAction = (payload: boolean) => createAction<typeof SET_CHART_DRAW_PANEL_OPENED, boolean>(SET_CHART_DRAW_PANEL_OPENED, payload);
export const initChartDrawPanelOpenedAction = (payload: boolean) => createAction<typeof INIT_CHART_DRAW_PANEL_OPENED, boolean>(INIT_CHART_DRAW_PANEL_OPENED, payload);